import axios from "axios"
const baseUrl = process.env.REACT_APP_API_URL

class CountryPreferenceApi {
  addCountryPreference(data, config) {
    return axios.post(`${baseUrl}/country/add`, data, config)
  }
  getAllCountry(query) {
    return axios.get(`${baseUrl}/country/all`, query)
  }

  updateCountryPreference(data, query) {
    return axios.put(`${baseUrl}/country/preference`, data, query)
  }

  searchCountry(params, query) {
    return axios.get(`${baseUrl}/country/search`, { params, ...query })
  }
}

export default new CountryPreferenceApi()
